import { TableColumnsType } from 'antd';
import TableComponent from 'components/Table/TableComponent';
import dayjs from 'dayjs';
import Content from 'layouts/Content';
import { forwardRef, useImperativeHandle, useMemo } from 'react';
import { formatCurrency } from 'utils/constants/functions';
import { HocChangePagination } from 'utils/HocChangePagination';

interface ITableSaleLineEfficiencyProps {
  loading?: boolean;
  data: any;
  exportExcel?: (columns: any) => void;
}

const TableSaleLineEfficiency = (
  { data, loading, exportExcel }: ITableSaleLineEfficiencyProps,
  ref: any,
) => {
  const columns: TableColumnsType = useMemo(
    () => [
      {
        width: 100,
        title: 'STT',
        // align: 'center',
        dataIndex: 'stt',
        render: (value) => (value && `${value}`) || value,
      },
      {
        type: 'date',
        format: 'DD/MM/YYYY',
        width: 100,
        title: 'Ngày',
        dataIndex: 'implementation_date',
        render: (value) => (value ? dayjs(value).format('DD/MM/YYYY') : '-'),
      },
      {
        width: 100,
        title: 'Mã đội',
        dataIndex: 'team_sales_id',
      },
      {
        width: 120,
        title: 'Mã chuyến',
        dataIndex: 'trip_id',
      },
      {
        width: 120,
        title: 'Mã tuyến',
        dataIndex: 'route_id',
      },
      {
        width: 120,
        title: 'Mã khách hàng',
        dataIndex: 'customer',
      },
      {
        title: 'Tổng quan',
        children: [
          {
            type: 'date',
            formatDate: 'HH:mm',
            width: 140,
            title: 'Thời gian bắt đầu',
            dataIndex: 'sale_started_date',
            render: (value) =>
              value ? dayjs(value).format('DD/MM/YYYY HH:mm') : '-',
          },
          {
            type: 'date',
            formatDate: 'HH:mm',
            width: 140,
            title: 'Thời gian kết thúc',
            dataIndex: 'sale_end_date',
            render: (value) =>
              value ? dayjs(value).format('DD/MM/YYYY HH:mm') : '-',
          },
          {
            isShowRender: true,
            width: 90,
            title: 'Thời lượng',
            dataIndex: 'total_time',
            render: (value) => (value ? value.substring(0, 5) : '-'),
          },
          {
            type: 'number',
            currency: 'vi-VN',
            width: 160,
            title: 'DT công kế hoạch',
            dataIndex: 'average_month_revenue',
            align: 'right',
            render: (value) =>
              value
                ? formatCurrency({
                    value,
                  })
                : '-',
          },
          {
            type: 'number',
            currency: 'vi-VN',
            width: 160,
            title: 'DT công thực hiện',
            dataIndex: 'process_price',
            align: 'right',
            render: (value) =>
              value
                ? formatCurrency({
                    value,
                  })
                : '-',
          },
          {
            width: 160,
            title: 'Tỷ lệ DT TH/KH',
            dataIndex: 'percent_price',
            align: 'right',
          },
          {
            type: 'number',
            currency: 'vi-VN',
            width: 160,
            title: 'Chi phí tuyến',
            dataIndex: 'average_revenue',
            align: 'right',
            render: (value) =>
              value
                ? formatCurrency({
                    value,
                  })
                : '-',
          },
        ],
      },
    ],
    [],
  );

  useImperativeHandle(ref, () => ({
    handleExportExcel,
  }));

  const handleExportExcel = () => {
    exportExcel && exportExcel(columns);
  };

  return (
    <Content>
      <TableComponent
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={data.items}
        rowKey={(record) =>
          (record?.sales_planning_id || '').toString() +
          (record?.sale_started_date || '').toString() +
          (record?.stt || '').toString()
        }
        loading={loading}
        pagination={{
          current: data.pageInfo?.currentPage,
          pageSize: data.pageInfo?.itemsPerPage,
          total: data.pageInfo?.totalItems,
          onChange: HocChangePagination(),
        }}
      />
    </Content>
  );
};

export default forwardRef(TableSaleLineEfficiency);
